import PredictionResult from './PredictionResult';

function Message({ message }) {
  const isUser = message.role === 'user';

  return (
    <div className={`msg ${message.role}`}>
      <div className={`avatar ${message.role}`}>
        {isUser ? 'U' : 'A'}
      </div>
      <div className="bubble">
        <div>{message.content}</div>
        {message.prediction && <PredictionResult prediction={message.prediction} />}
        {message.timestamp && (
          <div className="meta">
            <span className="muted">
              {new Date(message.timestamp).toLocaleTimeString()}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default Message;